import apiService from '../utils/apiService';
import {
  ADD_ROLE,
  ADD_ROLE_START,
  ADD_ROLE_ERROR,
  UPDATE_ROLE,
  UPDATE_ROLE_START,
  UPDATE_ROLE_ERROR,
  GET_ROLE_START,
  GET_ROLE_ERROR,
  GET_ROLE_LIST,
  GET_ROLE_LIST_START,
  GET_ROLE_LIST_ERROR,
  DELETE_ROLE,
  DELETE_ROLE_START,
  DELETE_ROLE_ERROR,
  GET_ACTION_LIST_START,
  GET_ACTION_LIST,
  GET_ACTION_LIST_ERROR,
  GET_ROLE_DTO_LIST_START,
  GET_ROLE_DTO_LIST_ERROR,
  ADD_ROLE_AND_RETURN_ROLE_DTO,
  ADD_ROLE_AND_RETURN_ROLE_DTO_START,
  ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR,
  CLEAR_ERROR_ROLE,
  GET_ROLES_HASHMAP_LIST,
  GET_ROLES_HASHMAP_LIST_START,
  GET_ROLES_HASHMAP_LIST_ERROR,
} from './types';

import {
  roleAddPath,
  roleUpdatePath,
  roleFindAllPath,
  roleFindByIdPath,
  roleDeletePath,
  actionsFindAllPath,
  roleFindAllDTOPath,
  roleAddAndReturnRoleDTOPath,
  rolefindAllHashMapListPath,
  roleFindAllPageablePath,
} from '../constants/apiEndpoints';

const clearError = () => {
  return {
    type: CLEAR_ERROR_ROLE,
  };
};

const addRoleStart = () => {
  return {
    type: ADD_ROLE_START,
  };
};
const addRoleSuccessfully = (data) => {
  return {
    type: ADD_ROLE,
    payload: data,
  };
};
const addRoleUnsuccessfully = (err) => {
  return {
    type: ADD_ROLE_ERROR,
    payload: err,
  };
};

const updateRoleStart = () => {
  return {
    type: UPDATE_ROLE_START,
  };
};
const updateRoleSuccessfully = (data) => {
  return {
    type: UPDATE_ROLE,
    payload: data,
  };
};
const updateRoleUnsuccessfully = (err) => {
  return {
    type: UPDATE_ROLE_ERROR,
    payload: err,
  };
};

const getRoleStart = () => {
  return {
    type: GET_ROLE_START,
  };
};

const getRoleUnsuccessfully = (err) => {
  return {
    type: GET_ROLE_ERROR,
    payload: err,
  };
};

const getRoleListStart = () => {
  return {
    type: GET_ROLE_LIST_START,
  };
};
const getRoleListSuccessfully = (data) => {
  return {
    type: GET_ROLE_LIST,
    payload: data,
  };
};

const getRolePageableListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_ROLE_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getRoleListUnsuccessfully = (err) => {
  return {
    type: GET_ROLE_LIST_ERROR,
    payload: err,
  };
};

const getRoleDTOListStart = () => {
  return {
    type: GET_ROLE_DTO_LIST_START,
  };
};

const getRoleDTOListUnsuccessfully = (err) => {
  return {
    type: GET_ROLE_DTO_LIST_ERROR,
    payload: err,
  };
};

const deleteRoleStart = () => {
  return {
    type: DELETE_ROLE_START,
  };
};
const deleteRoleSuccessfully = (id) => {
  return {
    type: DELETE_ROLE,
    payload: id,
  };
};
const deleteRoleUnsuccessfully = (err) => {
  return {
    type: DELETE_ROLE_ERROR,
    payload: err,
  };
};

const getActionListStart = () => {
  return {
    type: GET_ACTION_LIST_START,
  };
};
const getActionListSuccessfully = (data) => {
  return {
    type: GET_ACTION_LIST,
    payload: data,
  };
};
const getActionListUnsuccessfully = (err) => {
  return {
    type: GET_ACTION_LIST_ERROR,
    payload: err,
  };
};

const addRoleAndReturnRoleDTOStart = () => {
  return {
    type: ADD_ROLE_AND_RETURN_ROLE_DTO_START,
  };
};
const addRoleAndReturnRoleDTOSuccessfully = (data) => {
  return {
    type: ADD_ROLE_AND_RETURN_ROLE_DTO,
    payload: data,
  };
};
const addRoleAndReturnRoleDTOUnsuccessfully = (err) => {
  return {
    type: ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR,
    payload: err,
  };
};

const getRolesHashMapListStart = () => {
  return {
    type: GET_ROLES_HASHMAP_LIST_START,
  };
};
const getRolesHashMapListSuccessfully = (data) => {
  return {
    type: GET_ROLES_HASHMAP_LIST,
    payload: data,
  };
};
const getRolesHashMapListUnsuccessfully = (err) => {
  return {
    type: GET_ROLES_HASHMAP_LIST_ERROR,
    payload: err,
  };
};

export const createRole = (role, callback = () => {}) => {
  return (dispatch) => {
    dispatch(addRoleStart());
    return apiService
      .post(roleAddPath(), role)
      .then((response) => {
        dispatch(addRoleSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addRoleUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateRole = (role, callback) => {
  return (dispatch) => {
    dispatch(updateRoleStart());
    return apiService
      .post(roleUpdatePath(), role)
      .then((response) => {
        dispatch(updateRoleSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(updateRoleUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllRoles = () => {
  return (dispatch) => {
    dispatch(getRoleListStart());
    return apiService
      .get(roleFindAllPath())
      .then((response) => {
        dispatch(getRoleListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getRoleListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllRolesPageble = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getRoleListStart());
    return apiService
      .get(roleFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getRolePageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getRoleUnsuccessfully(err?.response?.data));
      });
  };
};

export const findRoleById = (id) => {
  return (dispatch) => {
    dispatch(getRoleStart());
    return apiService
      .get(roleFindByIdPath(id))
      .then((response) => {
        // dispatch(getRoleSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getRoleUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteRole = (id) => {
  return (dispatch) => {
    dispatch(deleteRoleStart());
    return apiService
      .delete(roleDeletePath(id))
      .then(() => {
        dispatch(deleteRoleSuccessfully(id));
      })
      .catch((err) => {
        dispatch(deleteRoleUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllRolesDTO = () => {
  return (dispatch) => {
    dispatch(getRoleDTOListStart());
    return apiService
      .get(roleFindAllDTOPath())
      .then((response) => {
        // dispatch(getRoleDTOListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getRoleDTOListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllActions = () => {
  return (dispatch) => {
    dispatch(getActionListStart());
    return apiService
      .get(actionsFindAllPath())
      .then((response) => {
        dispatch(getActionListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getActionListUnsuccessfully(err?.response?.data));
      });
  };
};

export const createRoleAndReturnRoleDTO = (role, callback) => {
  return (dispatch) => {
    dispatch(addRoleAndReturnRoleDTOStart());
    return apiService
      .post(roleAddAndReturnRoleDTOPath(), role)
      .then((response) => {
        dispatch(addRoleAndReturnRoleDTOSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addRoleAndReturnRoleDTOUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllRolesHashMapList = () => {
  return (dispatch) => {
    dispatch(getRolesHashMapListStart());
    return apiService
      .get(rolefindAllHashMapListPath())
      .then((response) => {
        dispatch(getRolesHashMapListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getRolesHashMapListUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteErrorRole = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};
